import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent } from "@/components/ui/card";
import { SequenceBuilder } from "./SequenceBuilder";

export const SequenceManager = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold tracking-tight">Email Sequences</h2>
      </div>

      <Card className="border-0 shadow-none">
        <CardContent className="p-0">
          <Tabs defaultValue="welcome" className="space-y-4">
            <TabsList className="bg-background border-b w-full rounded-none p-0 h-auto">
              <TabsTrigger 
                value="welcome" 
                className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-background"
              >
                Welcome Sequence
              </TabsTrigger>
              <TabsTrigger 
                value="newsletter" 
                className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-background"
              >
                Newsletter Sequence
              </TabsTrigger>
              <TabsTrigger 
                value="custom" 
                className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-background"
              >
                Custom Sequence
              </TabsTrigger>
              <TabsTrigger 
                value="history" 
                className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-background"
              >
                History
              </TabsTrigger>
            </TabsList>

            <TabsContent value="welcome" className="p-0">
              <SequenceBuilder defaultTemplate="welcome" />
            </TabsContent>

            <TabsContent value="newsletter" className="p-0">
              <SequenceBuilder defaultTemplate="newsletter" />
            </TabsContent>

            <TabsContent value="custom" className="p-0">
              <SequenceBuilder defaultTemplate="custom" />
            </TabsContent>

            <TabsContent value="history" className="p-0">
              <div className="space-y-4">
                <h3 className="text-lg font-semibold">Sequence History</h3>
                <p className="text-muted-foreground">View your sequence history and performance metrics.</p>
              </div>
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};